import angular from 'angular';

export default function toTimeDay(dateFilter, toDateFilter, toTimeFilter, Utils) {
  'ngInject';

  return function link(dateArg) {
    const date = !angular.isDate(dateArg) ? new Date(dateArg) : dateArg;

    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);

    const yesterday = Utils.addDays(today, -1);

    if (date > today) {
      return `Today at ${toTimeFilter(date)}`;
    }

    if (date > yesterday) {
      return `Yesterday at ${toTimeFilter(date)}`;
    }

    return `${toDateFilter(date)} at ${toTimeFilter(date)}`;
  };
}
